import { AbstractFormArgument } from './global'

class FormArgument extends AbstractFormArgument {
  constructor () {
    super()
    this.crmCode = ''
    this.crmTemplateId = ''
    this.id = ''
    this.type = ''
    this.wyCustomerId = ''
  }
}

export {
  FormArgument
}



// WEBPACK FOOTER //
// ./src/models/template-setting.js